<template>
  <v-container fluid>
    <v-snackbar v-model="snackbar.model" top :color="snackbar.color">
      {{ snackbar.detail }}
    </v-snackbar>
    <InvoiceDetail ref="itemDetail"
      @detail-display="loadList" @update-detail="loadList" @show-message="onMessageDisplay" />
    <InvoicePreview @close-preview="onMessageDisplay" @send-invoice="loadList" ref="itemPreview"/>

    <v-row no-gutters class="mt-4">
      <v-col cols="12" sm="6" md="3">
        <v-select dense label="Select entity" v-model="entityId" :loading="loading"
          @change="onEntityId" :items="entities" outlined></v-select>
      </v-col>
    </v-row>
    <v-divider/>
    <v-row :no-gutters="$vuetify.breakpoint.smAndDown">
      <v-tabs v-show="entityId" grow v-model="tabs">
        <v-tab @click="loadOptions">Invoices</v-tab>
        <v-tab @click="loadCustomers">Customers</v-tab>
        <v-tab @click="loadProdServices">Products &amp; Services</v-tab>
        <v-tab-item>
          <v-container>
            <v-row v-if="entityId">
              <v-col cols="4">
                <v-radio-group dense v-model="paid" class="mt-0" outlined row @change="setPaid">
                  <label class="mr-4">Invoice list</label>
                  <v-radio label="Unpaid" :value="false"></v-radio>
                  <v-radio label="Paid" :value="true"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="8">
                <v-btn small rounded color="success" @click="showEmptyDetail()">
                  Add invoice
                </v-btn>
              </v-col>
              <v-col :cols="12" class="entity-list">
                <InvoiceList @load-detail="loadDetail" @preview-detail="previewDetail" @reload="loadList"
                  @payment-added="PaymentAdded" ref="itemList" />
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <Customer ref="customer"/>
        </v-tab-item>
        <v-tab-item>
          <ProdService ref="prodService"/>
        </v-tab-item>
      </v-tabs>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { namespace, Action } from 'vuex-class'

import InvoiceList from './list'
import InvoiceDetail from './InvoiceDetail'
import InvoicePreview from './InvoicePreview'
import Customer from '@/components/customer'
import ProdService from '@/components/prodservice'

import { Api } from '@/services/Api'
import EntityService from '@/services/EntityService'

const InvoiceModule = namespace('invoice')

@Component({
  components: {
    InvoiceList,
    InvoiceDetail,
    InvoicePreview,
    Customer,
    ProdService
  }
})
export default class Invoice extends Vue {
  snackbar = { model: false }
  tabs = 0
  entityId = null
  loading = false
  entities = []
  bankAccounts = []
  invoices = null
  menus = {
    startDate: null,
    endDate: null
  }
  paid = false
  categoryTypes = []
  payState = null
  payStates = [
    { value: 'all', text: 'All' },
    { value: 'unpaid', text: 'Unpaid' },
    { value: 'paid', text: 'Paid history' }
  ]

  @Action setEntity
  @Action setPageTitle
  @InvoiceModule.Action setCategoryOptions
  @InvoiceModule.Action setAccountOptions
  @InvoiceModule.Action setCustomerOptions
  @InvoiceModule.Action setProdServiceOptions
  @InvoiceModule.Getter fields

  updateOptions (url, callback, prepare) {
    this.loading = true
    Api().get(url)
      .then(resp => {
        const data = (resp.data.results || resp.data).map(item => {
          if (prepare === undefined) {
            return {
              text: item.name,
              value: item.id
            }
          } else {
            return prepare(item)
          }
        })
        callback(data)
      })
      .finally(() => {
        this.loading = false
      })
  }

  loadCustomers () {
    const delay = this.$refs.customer ? 0 : 100
    setTimeout(() => {
      this.$refs.customer.load(this.entityId)
    }, delay)
  }

  loadProdServices () {
    const delay = this.$refs.prodService ? 0 : 100
    setTimeout(() => {
      this.$refs.prodService.load(this.entityId)
    }, delay)
  }

  onEntityId (val) {
    this.$nextTick(() => {
      EntityService.get(val)
        .then(resp => {
          this.setEntity(resp.data)
          this.loadOptions()
          this.loadList()
          this.tabs = 0
        })
    })
  }

  loadList () {
    this.$nextTick(() => {
      this.$refs.itemList.load(this.entityId)
      this.tabs = 0
    })
  }

  loadDetail (item) {
    this.$nextTick(() => {
      this.$refs.itemDetail.load(item.id)
    })
  }

  previewDetail (item) {
    this.$nextTick(() => {
      this.$refs.itemPreview.load(item.id)
    })
  }

  loadCustomer () {
    this.$nextTick(() => {
      this.$refs.customer.load(this.entityId)
    })
  }

  mounted () {
    this.setPageTitle('Invoice')
    this.loading = true
    EntityService.list_options()
      .then(resp => {
        this.entities = (resp.data.results || resp.data).map(item => {
          return {
            text: item.name,
            value: item.id
          }
        })
      })
      .finally(() => {
        this.loading = false
      })
  }

  loadOptions () {
    this.updateOptions(`/invoice/customer/?entity=${this.entityId}`, this.setCustomerOptions)
    this.updateOptions(`/invoice/service/?entity=${this.entityId}`, this.setProdServiceOptions)
  }

  showEmptyDetail () {
    this.$nextTick(() => {
      this.$refs.itemDetail.open()
    })
  }

  onMessageDisplay (data) {
    console.log('onMessageDisplay', data)
    this.snackbar = {
      model: true,
      detail: data.message + (data.error !== undefined ? `: ${data.error}` : ''),
      color: data.error === undefined ? 'success' : 'error'
    }
  }

  setPaid () {
    this.$refs.itemList.setPaid(this.paid)
  }

  PaymentAdded (data) {
    this.snackbar = data
    this.snackbar.model = true
    this.loadList()
  }
}
</script>
